import React, {useState} from "react";
import {ClipBoardService} from "../../../service/ClipBoardService";
import {useTranslation} from "react-i18next";

export const BIMIGeneratorForm = () => {
    const [bimiSettings, setBimiSettings] = useState({
        domain: '',
        logoUrl: '',
        authorityUrl: ''
    });

    const [dnsEntry, setDnsEntry] = useState('');
    const clipboarService = new ClipBoardService();
    const {t} = useTranslation();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBimiSettings(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const generateBimiRecord = ({ domain, logoUrl, authorityUrl }) => {
        if (!domain || !logoUrl) return '';
        const authorityPart = authorityUrl ? ` a=${authorityUrl};` : '';
        return `default._bimi.${domain} IN TXT "v=BIMI1; l=${logoUrl};${authorityPart}"`;
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const record = generateBimiRecord(bimiSettings);
        setDnsEntry(record);
    };

    return (
        <div className="container-fluid">
            <form onSubmit={handleSubmit} className="mb-4 bg-white p-4 p-md-5 rounded-3 shadow d-flex flex-column">
                <div className="mb-3">
                    <label htmlFor="domain" className="form-label">
                        {t("pages.bimiGenerator.form.domain.title")}
                    </label>
                    <input
                        type="text"
                        id="domain"
                        name="domain"
                        value={bimiSettings.domain}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={t("pages.bimiGenerator.form.domain.placeholder")}
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="logoUrl" className="form-label">
                        {t("pages.bimiGenerator.form.logoUrl.title")}
                    </label>
                    <input
                        type="text"
                        id="logoUrl"
                        name="logoUrl"
                        value={bimiSettings.logoUrl}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={t("pages.bimiGenerator.form.logoUrl.placeholder")}
                    />
                </div>

                <div className="mb-3">
                    <label htmlFor="authorityUrl" className="form-label">
                        {t("pages.bimiGenerator.form.authorityUrl.title")}
                    </label>
                    <input
                        type="text"
                        id="authorityUrl"
                        name="authorityUrl"
                        value={bimiSettings.authorityUrl}
                        onChange={handleChange}
                        className="form-control"
                        placeholder={t("pages.bimiGenerator.form.authorityUrl.placeholder")}
                    />
                </div>

                <div className="mb-3 text-end">
                    <button type="submit" className="btn btn-primary text-white">
                        {t("pages.bimiGenerator.form.generate")}
                    </button>
                </div>

                {dnsEntry && (
                    <div className="alert alert-success">
                        <h4>{t("pages.bimiGenerator.form.result.title")}</h4>
                        <p>{t("pages.bimiGenerator.form.result.subTitle")}</p>
                        <hr/>
                        <div className="d-flex justify-content-between flex-wrap">
                            <p className="font-monospace" style={{ wordBreak: "break-all" }}>{dnsEntry}</p>
                            <div>
                                <button className="btn btn-primary text-white" onClick={() => clipboarService.handleCopy(dnsEntry)}>
                                    {t("pages.bimiGenerator.form.result.copy")}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
};
